export default __webpack_public_path__ + "static/media/thumbnail.245f587c.png";